import moment from 'moment'
import numeral from 'numeral'
import { dateFormatTable, FileTypeEnum } from 'utils'

import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { FileMetaWithUsageSchemaFragment } from 'gql/__generated__/graphql'
import { prepareFinderItem } from 'utils/useFinder'

import { FinderFileIcons } from '../../FinderFileIcons'
import * as s from './FileReplacePreview.module.scss'

interface IFileReplacePreviewProps {
  file?: FileMetaWithUsageSchemaFragment | null
}

const FileReplacePreview = ({ file }: IFileReplacePreviewProps) => {
  if (!file) {
    return null
  }

  const preparedFile = prepareFinderItem(file, '')

  return (
    <div className={s.root}>
      <div className={s.image}>
        <FinderFileIcons item={preparedFile} typeFile={file.type.split('/')[0] as FileTypeEnum} />
      </div>
      <div className={s.info}>
        <Typography rows={1} weight='medium'>
          {preparedFile.name}
        </Typography>
        <div className={s.fileMeta}>
          <Typography size={KitSize.S} styleType='hint'>
            {numeral(preparedFile.size).format('0.0 b')}
            <span className={s.divider}>&#8729;</span>
            {moment(parseInt(preparedFile.createdAt)).format(dateFormatTable)}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default FileReplacePreview
